import Axios from 'axios'
import qs from "qs"
import Router from '../router'
import {Message} from "element-ui"
import {setToken, getToken, removeToken} from '@/assets/js/token.js'

//文件流配置开关
let b = false;
let onOff = false;


export const baseURL = process.env.VUE_APP_URL;
let axiosInstance = Axios.create({
	baseURL: baseURL,
	timeout: 30000,
	headers: {
		'Content-Type': 'application/json; charset=utf-8'
	}
});

//axios请求之前拦截器
axiosInstance.interceptors.request.use(
	function(config){
	    return config;
	},
	function(error){
	  	return Promise.reject(error);
	}
);
//axios响应拦截器
let resetToKen = '';
axiosInstance.interceptors.response.use((response)=>{
	let responseData = response.data;
	if(responseData.code === 1001){ //token失效或者过期
		removeToken()
		localStorage.removeItem('loginState');
		Router.push({name: 'login'})
	}else{
		return response;
	}
},function(error){
	Message({
        message:'请检查网络是否连接',
        type:'error',
        duration:5000
    });
})
//文件流导出配置
function exportFile(opt){
	resetToKen = new Promise((resolve,reject)=>{
		if(b){ //true的时候执行
			let url = '/phjrapi/refreshToken';
	        let client = new XMLHttpRequest();
	        let params = '';
	        client.open('post',url);
	        client.setRequestHeader('content-type','application/x-www-form-urlencoded');
	        params = "refresh_token=" + localStorage.getItem('e-refreshtoken');
	        client.send(params);
	        client.onreadystatechange = function(){
	        	if(client.readyState == '4' && client.status == '200'){
	        		let res = JSON.parse(client.responseText);
	        		let data = res.data;
	                if(res.code == '200'){
	                	setToken(data.access_token);
	      				localStorage.setItem('e-refreshtoken',data.refresh_token); //更新token
	      				localStorage.setItem('e-userList',JSON.stringify(data.func)); //更新导航
	      				resolve('success');
	                }else{
	                	localStorage.clear();
						//Router.push({name:'login'}); //返回登录页
						reject('fail');
	                }
	        	}
	        }
		}else{
			resolve('success');
		}
	})
	return resetToKen.then(function(){
        let contentType = ['application/x-www-form-urlencoded','application/json','multipart/form-data'];
	    let headers = {
	    	'content-type':contentType[opt.type]
	    };
    	var params = opt.params;
	    if(opt.token){
	        headers['x-access-token'] = getToken() || '';
	    }
	    if(opt.type == 0 && opt.method.toUpperCase() != "GET"){
	        params = qs.stringify(opt.params);
	    }
	    let axiosOptions = {
	    	method:opt.method,
	    	url:opt.url,
	    	headers:headers,
	    	responseType:'blob'
		};
		if(opt.method.toUpperCase() === "GET" || opt.method.toUpperCase() === "DELETE") {
		    axiosOptions['params'] = params;
		}else{
		    axiosOptions['data'] = params;
		}
		return axiosInstance(axiosOptions);

   	},function(error){
   		Message({
	        message:'请检查网络是否连接',
	        type:'error',
	        duration:5000
   	 	});
    })
}
/*
 	ajaxRequest(opt)--opt参数
	1.method: 请求方式get,post
	2.url:    请求地址
	3.type:   请求类型
		0为'application/x-www-form-urlencoded',
		1为'application/json',
		2为'multipart/form-data'
	4.params: 请求参数{key:value}
	5.token:  是否需要添加token,true为添加，false为不添加
*/

//axios请求配置
function ajaxRequest(opt){
    let contentType = ['application/x-www-form-urlencoded','application/json','multipart/form-data'];
    let headers = {
    	'content-type':contentType[opt.type]
    };
    let params = opt.params;
    if(opt.token){
        headers['x-access-token'] =  getToken() || '';
    }
    //post请求才执行qs解析
    if(opt.type == 0 && opt.method.toUpperCase() != "GET"){
        params = qs.stringify(opt.params);
    }
    let axiosOptions = {
    	method:opt.method,
    	url:opt.url,
    	headers:headers,
	};
	if(opt.method.toUpperCase() === "GET" || opt.method.toUpperCase() === "DELETE") {
	    axiosOptions['params'] = params;
	}else{
	    axiosOptions['data'] = params;
	}
	return axiosInstance(axiosOptions);

}

//导出
export {ajaxRequest,exportFile};
